import {p1, p2, p8, p16, p32} from "../pl_commons";
import React from "react";

const PlIcon = ({item, transform, children, width, height}) => {


    let boxcolor = '#818181'
    let stw = 0.5
    if( item && (!item.bus_available || item.bus_available === "false") && item.bus_available !== "true") {

        if( item.type === "sw") {
            //boxcolor = '#ad1a1a'
            //stw = 3

            //console.log("item.bus_available "+ item.bus_available)
        }
    }



    const box = <rect width={p1} height={p1} style={{fill: 'none', strokeWidth: stw+'px', stroke: boxcolor}} stroke={1}/>
    const ra = 2 // Math.floor(Math.random() * 2) + 1

    let bmbd = undefined;
    if( item) {
        let bmbdcolor = '#adadad'
        if( item.bmbd === "center") {
            bmbd = <rect x={p2-p32} y={p2-p16} width={p16} height={p8} fill={bmbdcolor}/>
        } else if( item.bmbd === "east") {
            bmbd = <rect x={p1-p16} y={p2-p16} width={p16} height={p8} fill={bmbdcolor}/>
        } else if( item.bmbd === "west") {
            bmbd = <rect x={p16} y={p2-p16} width={p16} height={p8} fill={bmbdcolor}/>
        } else if( item.bmbd === "south") {
            bmbd = <rect x={p2-p16} y={p1-p16} width={p8} height={p16} fill={bmbdcolor}/>
        } else if( item.bmbd === "north") {
            bmbd = <rect x={p2-p16} y={0} width={p8} height={p16} fill={bmbdcolor}/>
        }
    }

    // <image href={'kachel_0'+ra+'.png'} width={p1} height={p1}></image>
    //
    let itemok = true
    if( item && item.bus_available === "offline"){
        itemok = false
    }

    //ref={setNodeRef}

    return (
        <div>
        <svg width={width || p1} height={height || p1} transform={transform}>
            {!itemok || (item && item.type === "tt")?null:<image href={'kachel_0'+ra+'.png'} width={p1} height={p1}></image>}
            {item && item.type === "tt"?null:<rect x={0} y={0} width={width || p1} height={height || p1} fill={'rgba(178,211,175,0)'} stroke={'rgb(150,164,157,0.23)'} strokeWidth={1}/>}
            {children}
            {bmbd}
            {item && item.type === "tt"?null:box}
        </svg>

        </div>
    )

}

export default PlIcon
